import {NgModule} from '@angular/core';
import {EuAppConfigPage} from "./page/overview/eu-app-config/eu-app-config.page";
import {EuOverviewPage} from "./page/overview/eu-overview/eu-overview.page";
import {EuRegistrationOverviewPage} from "./page/overview/eu-registration-overview/eu-registration-overview.page";
import {
    EuRegistrationObjectComponent
} from "./component/protected-components/eu-registration-object/eu-registration-object.component";
import {
    EuRegistrationInlineComponent
} from "./component/protected-components/eu-registration-inline/eu-registration-inline.component";
import {EuConfigComponent} from "./page/overview/eu-config-page/eu-config.component";
import {EuConfigPageWebappComponent} from "./page/overview/eu-config-page-webapp/eu-config-page-webapp.component";
import {OverviewEuPage} from "./page/eu-overview-page/overview-eu.page";
import {EuKpiComponent} from "./page/eu-overview-page/components/kpiComponent/eu-kpi.component";
import {EuStatisticsComponent} from "./page/eu-overview-page/components/statisticsComponent/eu-statistics.component";
import {
    EuUserAddedInsurancePendingComponent
} from "./page/overview/eu-registration-overview/components/eu-user-added-insurance-pending/eu-user-added-insurance-pending.component";
import {EU_ENTITY_PROVIDER} from "./eu.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {EU_TEST_PROVIDERS} from "./test/eu-test-definition";
import {
  EuStaticNotificationObjectComponent
} from "./component/protected-components/eu-static-notification-object/eu-static-notification-object.component";


@NgModule({
  declarations: [
    EuAppConfigPage,
    EuOverviewPage,
    EuRegistrationOverviewPage,
    EuRegistrationObjectComponent,
    EuRegistrationInlineComponent,
    EuConfigComponent,
    EuConfigPageWebappComponent,
    OverviewEuPage,
    EuKpiComponent,
    EuStatisticsComponent,
    EuUserAddedInsurancePendingComponent,
    EuStaticNotificationObjectComponent
  ],
  exports:[
    EuAppConfigPage,
    EuOverviewPage,
    EuRegistrationOverviewPage,
    EuRegistrationObjectComponent,
    EuRegistrationInlineComponent,
    EuConfigComponent,
    EuConfigPageWebappComponent,
    EuUserAddedInsurancePendingComponent,
  ],
  imports: [
    CoreModule,
    UiModule,
  ],
  providers: [EU_ENTITY_PROVIDER, EU_TEST_PROVIDERS]
})
export class EuModule  implements DynamicModule {

  alias = 'eu';

  constructor(private moduleRegistry: ModuleRegistryService) {
    this.moduleRegistry.registerModule(this);
  }

  getKpiComponent() {
    return EuKpiComponent;
  }

  getStatisticsComponent() {
    return EuStatisticsComponent;
  }
}
